module.exports = __webpack_public_path__ + "img/canbit-web.445aeecd.png";